import { createFileRoute } from "@tanstack/react-router";
import { AdminPageHeader } from "@/components/admin/admin-page-header";
import { UserManagementPage } from "@/components/users";
import { requireMinRole } from "@/lib/route-guards";

function UserManagement() {
  return (
    <div className="p-4 lg:p-7 space-y-6">
      <AdminPageHeader
        title="User Management"
        description="View, invite, and manage users across the platform, including pending invitations."
      />
      <UserManagementPage />
    </div>
  );
}

export const Route = createFileRoute("/dashboard/_admin/user-management")({
  component: UserManagement,
  beforeLoad: ({ context }) => {
    // User management is platform-admin only, mirroring company/sites.
    // Non-admins get the explicit "not authorised" page (CTE-127).
    requireMinRole(context.session, "admin", "/no-access");
  },
  staticData: {
    title: "User Management",
  },
});
